import { makeAutoObservable } from "mobx";
import { User } from "src/models/user";
import { decryptMessage, deleteLocalInfo, getLocalInfo, storeLocalInfo } from "src/utils/encrypt";
import {jwtDecode} from "jwt-decode";
import toast from "react-hot-toast";
import { signalRService } from "src/services/signalRService";

export class UserStore {
  user: User | null = null;

  constructor() {
    makeAutoObservable(this);
    this.fetchUser();
  }

  async fetchUser() {
    const token = getLocalInfo('accessToken');
    if (token) {
      const decryptedToken = jwtDecode(decryptMessage(token));
      const currentTime = Math.floor(Date.now() / 1000);
      if (decryptedToken.exp && decryptedToken.exp > currentTime) {
        this.user = User.fromJson(decryptedToken);
        await signalRService.connect();
        setTimeout(() => {
          this.joinUserGroups();
        }, 1000);
      } else {
        this.user = null;
      }
    }
  }

  async updateUser(token:string) {
    if (token) {
      storeLocalInfo('accessToken', token);
      const decryptedToken = jwtDecode(decryptMessage(token));
      const currentTime = Math.floor(Date.now() / 1000);
      if (decryptedToken.exp && decryptedToken.exp > currentTime) {
        this.user = User.fromJson(decryptedToken);
        await signalRService.connect();
        
        setTimeout(() => {
          this.joinUserGroups();
        }, 1000);
      } else {
        this.user = null;
      }
    }
  }

  private async joinUserGroups() {
    if (!this.user) return;

    const userType = this.user.role?.toLowerCase();
    const userId = this.user.nameid;

    if (!userType || !userId) return;

    const groups: string[] = [];

    switch (userType) {
      case 'doctor':
        groups.push('doctors', userId);
        break;
      case 'patient':
        groups.push('patients', userId);
        break;
      case 'admin':
        groups.push('admins', userId);
        break;
      case 'superadmin':
        groups.push('superadmins', userId);
        break;
    }

    if (groups.length > 0) {
      try {
        await signalRService.joinGroups(groups);
      } catch (error) {
        console.error('Failed to join groups:', error);
      }
    }
  }

  async logout() {
      await signalRService.disconnect();
      deleteLocalInfo('accessToken');
      this.user = null;
      toast.success('Logout successful')
    }
}